module.exports = __webpack_public_path__ + "img/Land-Mobile-tiled.f5ecb8a4.png";